import {combineReducers} from "redux";
import auth from "../reducers/auth";
import language from "../reducers/language";
import languageList from "../reducers/languageList";
import menu from "../reducers/menu"
import languageItem from "../reducers/languageItem"
import languageItemIstatistics from "../reducers/languageItemIstatistics"
import appReducer from "../reducers/AppReducer"

const rootReducer = combineReducers({
    auth,
    language,
    languageList,
    menu,
    languageItem,
    languageItemIstatistics,
    appReducer
})

export default rootReducer;
